module.exports = __webpack_public_path__ + "static/media/Thecakefactory.31bc14d8.png";